module.exports = __webpack_public_path__ + "static/media/settings-red.12c36b2a.svg";